<template>
    <section class="section my-0">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <card type="secondary" shadow header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5"
                    class="border-0">
                    <template>
                        <h6 slot="header" class="modal-title text-success font-weight-bold" id="modal-title-default">
                            Pendaftaran Akun
                        </h6>
                        <div class="d-block">
                            <ValidationObserver v-slot="{ handleSubmit }">
                                <form ref="form" @submit.stop.prevent="handleSubmit(submit)">
                                    <p class="description">
                                        * Registrasi User, silahkan isi field di bawah ini.
                                    </p>
                                    <div class="alert alert-default">
                                        <strong>Informasi!</strong> :
                                        <ul>
                                            <li>
                                                Harap periksa email yang akan Anda gunakan, dan pastikan email tersebut
                                                aktif.
                                            </li>
                                            <li>
                                                Sebelum Anda dapat login, Anda akan menerima email aktivasi terlebih dan
                                                harus mengaktifkan email tersebut
                                            </li>
                                            <li>
                                                Khusus untuk pilihan PPAT Anda akan diverifikasi lebih lanjut oleh
                                                Admin.
                                            </li>
                                            <li>
                                                Gunakan NIB jika Anda adalah wajib pajak BADAN.
                                            </li>
                                            <li>
                                                Jika Anda sudah mendaftar tapi tidak menerima email verifikasi silahkan
                                                klik: <a style="cursor: pointer;" @click="goVerification()">kirim ulang
                                                    verifikasi email</a>.
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="alert alert-danger" v-if="error_msg.length > 0">
                                        <strong>Warning!</strong> Perbaiki hasil input Anda :
                                        <ul>
                                            <li v-for="text in error_msg" :key="text">{{ text }}</li>
                                        </ul>
                                    </div>
                                    <div class="mb-5">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <div class="col-md-12 col-sm-12">
                                                        <div class="form-check-inline">
                                                            <base-checkbox class="mb-3 mr-3" v-model="form.is_ppat">
                                                                Sebagai PPAT
                                                            </base-checkbox>
                                                            <base-checkbox class="mb-3 mr-3" v-model="form.is_wajib_pajak">
                                                                Sebagai Wajib Pajak
                                                            </base-checkbox>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-6 col-sm-12">
                                                        <ValidationProvider name="NIK / NIB" rules="required|min:13|numeric"
                                                            v-slot="{ errors }">
                                                            <base-input label="NIK / NIB" v-model="form.wajib_pajak.nik"
                                                                :required="true" :error="errors[0]"
                                                                :valid="!errors[0]"></base-input>
                                                        </ValidationProvider>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <!-- <div class="col-sm-4 mb-2">
                                <base-input label="NPWP" v-model="form.wajib_pajak.npwp" />
                              </div> -->
                                                    <div class="col-md-8 mb-2">
                                                        <ValidationProvider name="Nama Wajib Pajak" rules="required|max:60"
                                                            v-slot="{ errors }">
                                                            <base-input label="Nama Wajib Pajak"
                                                                v-model="form.wajib_pajak.nama" :required="true"
                                                                :error="errors[0]" :valid="!errors[0]" />
                                                        </ValidationProvider>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6 mb-2">
                                                        <ValidationProvider name="Jalan" rules="required|max:30"
                                                            v-slot="{ errors }">
                                                            <base-input label="Jalan" v-model="form.wajib_pajak.jalan"
                                                                :required="true" :error="errors[0]" :valid="!errors[0]" />
                                                        </ValidationProvider>
                                                    </div>
                                                    <div class="col-sm-2 mb-2">
                                                        <ValidationProvider name="Blok/Kav/No." rules="required|max:10"
                                                            v-slot="{ errors }">
                                                            <base-input label="Blok/Kav/No."
                                                                v-model="form.wajib_pajak.blok_kav_no" :required="true"
                                                                :error="errors[0]" :valid="!errors[0]" />
                                                        </ValidationProvider>
                                                    </div>
                                                    <div class="col-sm-2 mb-2">
                                                        <ValidationProvider name="RT" rules="required|max:3"
                                                            v-slot="{ errors }">
                                                            <base-input type="number" label="RT"
                                                                v-model="form.wajib_pajak.rt" :required="true"
                                                                :error="errors[0]" :valid="!errors[0]" />
                                                        </ValidationProvider>
                                                    </div>
                                                    <div class="col-sm-2 mb-2">
                                                        <ValidationProvider name="RW" rules="required|max:3"
                                                            v-slot="{ errors }">
                                                            <base-input type="number" label="RW"
                                                                v-model="form.wajib_pajak.rw" :required="true"
                                                                :error="errors[0]" :valid="!errors[0]" />
                                                        </ValidationProvider>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-3 mb-2">
                                                        <ValidationProvider name="Kelurahan / Desa" rules="required|max:50"
                                                            v-slot="{ errors }">
                                                            <base-input label="Kelurahan / Desa"
                                                                v-model="form.wajib_pajak.kelurahan" :required="true"
                                                                :error="errors[0]" :valid="!errors[0]" />
                                                        </ValidationProvider>
                                                    </div>
                                                    <div class="col-sm-3 mb-2">
                                                        <ValidationProvider name="Kecamatan" rules="required|max:50"
                                                            v-slot="{ errors }">
                                                            <base-input label="Kecamatan"
                                                                v-model="form.wajib_pajak.kecamatan" :required="true"
                                                                :error="errors[0]" :valid="!errors[0]" />
                                                        </ValidationProvider>
                                                    </div>
                                                    <div class="col-sm-3 mb-2">
                                                        <ValidationProvider name="Kabupaten/Kota" rules="required|max:50"
                                                            v-slot="{ errors }">
                                                            <base-input label="Kabupaten/Kota"
                                                                v-model="form.wajib_pajak.kota" :required="true"
                                                                :error="errors[0]" :valid="!errors[0]" />
                                                        </ValidationProvider>
                                                    </div>
                                                    <div class="col-sm-3 mb-2">
                                                        <ValidationProvider name="Kode Pos" rules="max:5"
                                                            v-slot="{ errors }">
                                                            <base-input type="number" label="Kode Pos"
                                                                v-model="form.wajib_pajak.kd_pos" :error="errors[0]"
                                                                :valid="!errors[0]" />
                                                        </ValidationProvider>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-6 col-sm-12">
                                                        <ValidationProvider name="No Tlp. / WA"
                                                            rules="required|max:13|numeric" v-slot="{ errors }">
                                                            <base-input label="No Tlp. / WA" v-model="form.phone_number"
                                                                :required="true" :error="errors[0]"
                                                                :valid="!errors[0]"></base-input>
                                                        </ValidationProvider>
                                                    </div>
                                                    <div class="col-md-6 col-sm-12">
                                                        <ValidationProvider name="Email" rules="required|email"
                                                            v-slot="{ errors }">
                                                            <base-input label="Email" v-model="form.email" :required="true"
                                                                :error="errors[0]" :disabled="edit"
                                                                :valid="!errors[0]"></base-input>
                                                        </ValidationProvider>
                                                    </div>
                                                </div>

                                                <fieldset v-if="!edit">
                                                    <legend>Password User</legend>
                                                    <div class="row">
                                                        <div class="col-md-6 col-sm-12">
                                                            <ValidationProvider name="Password"
                                                                rules="required|max:20|min:6" v-slot="{ errors }">
                                                                <base-input type="password" placeholder="Password"
                                                                    addon-left-icon="ni ni-lock-circle-open"
                                                                    v-model="form.password" :required="true"
                                                                    :error="errors[0]" :valid="!errors[0]"></base-input>
                                                            </ValidationProvider>
                                                        </div>

                                                        <div class="col-md-6 col-sm-12">
                                                            <ValidationProvider name="Konfirmasi Password"
                                                                rules="required|max:20|min:6" v-slot="{ errors }">
                                                                <base-input type="password"
                                                                    placeholder="Password Konfirmasi"
                                                                    addon-left-icon="ni ni-lock-circle-open"
                                                                    v-model="form.password_confirmation" :required="true"
                                                                    :error="errors[0]" :valid="!errors[0]"></base-input>
                                                            </ValidationProvider>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row float-right">
                                        <div class="col-md-12 col-sm-12">
                                            <template v-if="isBusy">
                                                <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                                                <strong>Loading...</strong>
                                            </template>
                                            <base-button v-else type="success" nativeType="submit" icon="ni ni-send">{{
                                                edit ? "Ubah Data Pribadi" : "Daftar" }}
                                            </base-button>
                                        </div>
                                    </div>
                                </form>
                            </ValidationObserver>
                        </div>
                    </template>
                </card>
            </div>
        </div>
    </section>
</template>
<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Swal from "sweetalert2";
import qs from "qs";
import axios from "axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
export default {
    components: {
        PulseLoader,
        ValidationProvider,
        ValidationObserver,
        vSelect,
    },
    data() {
        return {
            form: {
                id: null,
                nik: null,
                name: null,
                email: null,
                phone_number: null,
                status_user: 2,
                password: null,
                password_confirmation: null,
                address: null,
                is_wajib_pajak: true,
                is_ppat: false,
                wajib_pajak: {
                    nik: null,
                    nama: null,
                    npwp: null,
                    jalan: null,
                    blok_kav_no: null,
                    rt: null,
                    rw: null,
                    kelurahan: null,
                    kecamatan: null,
                    kota: null,
                    kd_pos: null,
                },
            },
            isBusy: false,
            error_msg: [],
            edit: false,
        };
    },
    watch: {
        "form.wajib_pajak.nik": function (value) {
            this.getNik(value);
        },
    },
    mounted() {
        this.updateMode()
    },
    methods: {
        goVerification() {
            this.$router.push('/send-verification-email')
        },
        async getNik(nik) {
            if (
                nik == null ||
                nik == "" ||
                (nik.length < 13)
            )
                return;

            const me = this
            me.form.wajib_pajak.nama = null;
            me.form.wajib_pajak.npwp = null;
            me.form.wajib_pajak.jalan = null;
            me.form.wajib_pajak.blok_kav_no = null;
            me.form.wajib_pajak.rt = null;
            me.form.wajib_pajak.rw = null;
            me.form.wajib_pajak.kelurahan = null;
            me.form.wajib_pajak.kecamatan = null;
            me.form.wajib_pajak.kota = null;
            me.form.wajib_pajak.kd_pos = null;

            return axios
                .get("/api/v1/bphtb/cek-wajib-pajak?nik=" + nik)
                .then(function (response) {
                    if (response.data.wajib_pajak.subjek_pajak_id) {

                        me.form.nik = nik;
                        me.form.name = response.data.wajib_pajak.nm_wp;
                        me.form.wajib_pajak.nama = response.data.wajib_pajak.nm_wp;
                        me.form.wajib_pajak.npwp = response.data.wajib_pajak.npwp;
                        me.form.wajib_pajak.jalan = response.data.wajib_pajak.jalan_wp;
                        me.form.wajib_pajak.blok_kav_no =
                            response.data.wajib_pajak.blok_kav_no_wp;
                        me.form.wajib_pajak.rt = response.data.wajib_pajak.rt_wp;
                        me.form.wajib_pajak.rw = response.data.wajib_pajak.rw_wp;
                        me.form.wajib_pajak.kelurahan =
                            response.data.wajib_pajak.kelurahan_wp;
                        me.form.wajib_pajak.kecamatan = null;
                        me.form.wajib_pajak.kota = response.data.wajib_pajak.kota_wp;
                        me.form.wajib_pajak.kd_pos = response.data.wajib_pajak.kd_pos_wp;
                    } else {
                        me.form.nik = nik;
                        me.form.name = response.data.wajib_pajak.nama;
                        me.form.wajib_pajak.nama = response.data.wajib_pajak.nama;
                        me.form.wajib_pajak.npwp = response.data.wajib_pajak.npwp;
                        me.form.wajib_pajak.jalan = response.data.wajib_pajak.jalan;
                        me.form.wajib_pajak.blok_kav_no =
                            response.data.wajib_pajak.blok_kav_no;
                        me.form.wajib_pajak.rt = response.data.wajib_pajak.rt;
                        me.form.wajib_pajak.rw = response.data.wajib_pajak.rw;
                        me.form.wajib_pajak.kelurahan = response.data.wajib_pajak.kelurahan;
                        me.form.wajib_pajak.kecamatan = response.data.wajib_pajak.kecamatan;
                        me.form.wajib_pajak.kota = response.data.wajib_pajak.kota;
                        me.form.wajib_pajak.kd_pos = response.data.wajib_pajak.kd_pos;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateMode() {
            if (this.$store.state.auth.status.loggedIn) {
                this.form.id = this.$store.state.auth.user.id;
                this.form.wajib_pajak.nik = this.$store.state.auth.user.nik;
                this.form.email = this.$store.state.auth.user.email;
                this.form.phone_number = this.$store.state.auth.user.phone_number;
                this.form.is_ppat = this.$store.state.auth.user.is_ppat;
                this.form.is_wajib_pajak = this.$store.state.auth.user.is_wajib_pajak;
                this.edit = true;
            }
        },
        async submit() {
            const me = this;
            try {
                me.error_msg = [];
                this.isBusy = true;
                let { data, status } = this.edit ? await axios.post(
                    "/api/v1/user/update",
                    qs.stringify({ user_online: me.form })
                ) : await axios.post(
                    "/api/v1/register",
                    qs.stringify({ user_online: me.form })
                );

                if (status >= 200 && status <= 202) {
                    Swal.fire({
                        title: "",
                        text: data.msg,
                        icon: "success",
                        showCancelButton: false,
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: "Tutup!",
                    }).then(() => {
                        if(this.edit){
                            this.$store.dispatch("auth/set_user", data.user);
                        } else {
                            this.$router.push("/landing");
                        }
                    });
                }
                this.isBusy = false;
            } catch (error) {
                this.isBusy = false;
                // console.log(error.response);
                me.error_msg = ['Server Aplikasi sedang bermasalah. Silahkan coba kembali nanti'];
                Swal.fire({
                    title: "",
                    text: error.message,
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Tutup!",
                });
            } finally {
                this.isBusy = false;
            }
        },
    },
};
</script>